export enum FirmType {
  AssetManager = 0,
  Company = 1,
}

export default FirmType
